export const DEFAULT_DEVELOPER_TYPE = 'Developer';
export const DEVELOPER_TYPES = {
  frontend: 'Front End',
  backend: 'Back End',
  fullstack: 'Full Stack',
};
